import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface RequirementCoverageDTO {
  id: string;
  requirementId: string;
  testCaseId: string;
  coverageKind: string;
}

@Injectable({ providedIn: 'root' })
export class RequirementCoverageService {
  private http = inject(HttpClient);
  private base = `${environment.apiBaseUrl}/api/v1/projects`;

  private url(projectId: string, requirementId: string): string {
    return `${this.base}/${projectId}/requirements/${requirementId}/test-cases`;
  }

  list(projectId: string, requirementId: string): Observable<RequirementCoverageDTO[]> {
    return this.http.get<RequirementCoverageDTO[]>(this.url(projectId, requirementId));
  }

  link(projectId: string, requirementId: string, testCaseId: string): Observable<RequirementCoverageDTO> {
    return this.http.post<RequirementCoverageDTO>(`${this.url(projectId, requirementId)}/${testCaseId}`, null);
  }

  unlink(projectId: string, requirementId: string, testCaseId: string): Observable<void> {
    return this.http.delete<void>(`${this.url(projectId, requirementId)}/${testCaseId}`);
  }
}
